import { useQuery } from '@tanstack/react-query';
import { createRetryFn } from '../../../config/react-query';
import useApiManager from '../../../hooks/useApiManager';
import type { ConfMapperResponse } from '../../../services/phoneService';

const useConfMapper = (room: string | undefined) => {
  const apiManager = useApiManager();

  const { data, isLoading, isError, error } = useQuery<ConfMapperResponse | null>({
    queryKey: ['confMapper', room],
    queryFn: async () => {
      if (!room) {
        return null;
      }
      return apiManager.phone.getConfMapper(room);
    },
    enabled: !!room,
    staleTime: 5 * 60 * 1000,
    retry: createRetryFn({ maxRetries: 2 }),
  });

  const pin = data?.id ?? null;

  return {
    confMapper: data,
    pin,
    isLoading,
    isError,
    error,
  };
};

export default useConfMapper;
